import type { Guide } from '../types';

/** S-21.10-10 — kontrahent z kartoteki na prezleceniu (scenariusz e2e 16, ścieżki ADM-06, MIX-01; BR-ADM-13). */
export const guide: Guide = {
  flagKey: 'preOrderContractor',
  title: 'Kontrahent z kartoteki na prezleceniu',
  whatItDoes:
    'Na prezleceniu pole „Kontrahent z kartoteki”: wyszukiwarka po nazwie, numerze klienta w TMS albo NIP podpowiada z nazwy klienta, a wybiera człowiek. Rekomendowana stawka VAT liczy się wtedy z kontrahenta jeszcze przed połączeniem z TMS. Klient spoza kartoteki zostaje samą nazwą — podpowiedź VAT mówi wtedy „brak danych” z powodem. Wybór nie zmienia pliku dla VIA.',
  audience: ['CS', 'Administracja'],
  presentationItems: ['S-21.10-10'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: { description: 'prezlecenie z samą nazwą klienta', listPath: '/pre-orders' },
      target: 'pre-order-contractor',
      mockupTestId: 'cs-zlecenie-oddzial',
      title: 'Pole „Kontrahent z kartoteki”',
      description:
        'Na karcie prezlecenia: wybrany kontrahent i źródło wyboru albo „Nie wybrano” — wtedy podpowiedź VAT nie ma danych.',
      action: 'Na karcie prezlecenia znajdź sekcję „Kontrahent z kartoteki”.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: { description: 'prezlecenie z samą nazwą klienta', listPath: '/pre-orders' },
      target: 'contractor-option-*',
      title: 'Wybór z wyszukiwarki',
      description:
        'Podpowiedzi pokazują NIP albo numer klienta w TMS i miejscowość, więc da się odróżnić oddziały. Przy kilku oddziałach z jednym NIP — ostrzeżenie.',
      action: 'Kliknij „Wybierz z kartoteki”, wpisz nazwę, numer w TMS albo NIP, wybierz kontrahenta i zapisz.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'b1PreOrderId' },
        actions: [
          { kind: 'click', target: 'pre-order-contractor-change' },
          { kind: 'click', target: 'contractor-picker-input' },
          { kind: 'fill', target: 'contractor-picker-input', value: 'DEMO Kontrahent' },
        ],
      },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: { description: 'prezlecenie u Administracji z samą nazwą klienta', listPath: '/pre-orders' },
      target: 'control-vat',
      mockupTestId: 'adm-zlecenie-decyzja-vat',
      title: 'VAT w oknie kontroli',
      description:
        'Bez kontrahenta podpowiedź VAT mówi „brak danych — jest tylko nazwa klienta”. Administracja może wybrać kontrahenta w oknie kontroli; stawka liczy się od razu, z opisem, skąd kontrahent.',
      action: 'W oknie kontroli wybierz kontrahenta w sekcji „Kontrahent z kartoteki”.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'vatPreOrders.pick' } },
    },
  ],
};
